import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { FAQItemList } from "./components/faq-item-list";

export const FAQOthers = () => {
  return (
    <>
      <FAQSectionTitle>
        Pertanyaan Lainnya
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Bagaimana cara menghubungi layanan pengaduan dan pertanyaan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Contact WA Customer Service Jooalan: 0819-10000-118',
              'Contact Email Customer Service Jooalan: cuan@jooalan.id',
            ]}
          />
        </FAQItem>
      </Disclosure>
    </>
  )
}